module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921115651_T.8a05a3b6.jpg";